/**
 * Formats a raw phone input string into (###)###-#### mask.
 * Strips leading "1" (country code) and all non-digits.
 * Caps at 10 digits.
 */
export function formatPhone(value: string): string {
  // Strip all non-digits
  let digits = value.replace(/\D/g, '')

  // Remove leading "1" (US country code)
  if (digits.startsWith('1') && digits.length > 0) {
    digits = digits.slice(1)
  }

  // Cap at 10 digits
  digits = digits.slice(0, 10)

  // Apply mask
  if (digits.length === 0) return ''
  if (digits.length <= 3) return `(${digits}`
  if (digits.length <= 6) return `(${digits.slice(0, 3)})${digits.slice(3)}`
  return `(${digits.slice(0, 3)})${digits.slice(3, 6)}-${digits.slice(6)}`
}

/**
 * Strips a formatted phone string down to digits only (for webhook submission).
 */
export function stripPhone(value: string): string {
  return value.replace(/\D/g, '')
}
